export const Permissions = {
  BasicAcces:{ id: 'basicAccess', code : 100, display : "permissions.basicAccess", shortDisplay : "BAC" },
  ManageKN: { id: 'manage-komunalne-obv', code: 300, display: "permissions.komunalne_obv", shortDisplay: "MKN" },
  Administration: {id: 'administration', code: 900, display: "permissions.administration", shortDisplay: "ADM"},
  Operations: { id: 'operations', code: 800, display: "permissions.operations", shortDisplay: "OPS"}
}
